import { gql } from 'apollo-boost';

export const bidModifiersFragment = gql`
    fragment bidModifiersFragment on GdBidModifier {
        id
        enabled
        type
        adjustments {
            id
            percent

            ... on GdBidModifierRetargetingAdjustment {
                accessible
                retargetingConditionId
            }

            ... on GdBidModifierDemographicsAdjustment {
                age
                gender
            }

            ... on GdBidModifierMobileAdjustment {
                osType
            }

            ... on GdBidModifierWeatherAdjustment {
                expression {
                    operation
                    parameter
                    value
                }
            }
        }
    }
`;
